export default __webpack_public_path__ + "static/media/SidhantPuntambekarResume2026-2027.e2a16634.pdf";